
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line

/**
 * ClientReportSendType enum
 */
class ClientReportSendType {
  /**
   * Initialize enum with a given value
   * @param {ClientReportSendType|number|Int64|UInt64=} value Enum value, defaults is 0
   * @constructor
   */
  constructor (value = 0) {
    if (value instanceof ClientReportSendType) {
      this.value = value.value
    } else {
      this.value = value
    }
  }

  /**
   * Is this enum equal to other one?
   * @this {!ClientReportSendType}
   * @param {!ClientReportSendType} other Other enum
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof ClientReportSendType)) {
      throw new TypeError('Instance of ClientReportSendType is required!')
    }
    return this.value === other.value
  }

  /**
   * Get enum value
   * @this {!ClientReportSendType}
   * @returns {!number|!Int64|!UInt64} Enum value
   */
  valueOf () {
    return this.value
  }

  /**
   * Convert enum to string
   * @this {!ClientReportSendType}
   * @returns {!string} Enum value string
   */
  toString () {
    if (this.value === ClientReportSendType.UNKNOWN.value) {
      return 'UNKNOWN'
    }
    if (this.value === ClientReportSendType.SINGLE.value) {
      return 'SINGLE'
    }
    if (this.value === ClientReportSendType.ALL_UNSENT.value) {
      return 'ALL_UNSENT'
    }
    if (this.value === ClientReportSendType.ALL.value) {
      return 'ALL'
    }
    return '<unknown>'
  }

  /**
   * Inspect enum
   * @this {!ClientReportSendType}
   * @returns {!string} Enum value string
   */
  [util.inspect.custom] () {
    return this.toString()
  }

  /**
   * Convert enum to JSON
   * @this {!ClientReportSendType}
   * @returns {!number} Enum value for JSON
   */
  toJSON () {
    return this.value
  }

  /**
   * Create enum from object value
   * @param {!number} other Object value
   * @returns {!ClientReportSendType} Created enum
   */
  static fromObject (other) {
    return new ClientReportSendType(other)
  }
}

// noinspection PointlessArithmeticExpressionJS
ClientReportSendType.UNKNOWN = new ClientReportSendType(0 + 0)
// noinspection PointlessArithmeticExpressionJS
ClientReportSendType.SINGLE = new ClientReportSendType(0 + 1)
// noinspection PointlessArithmeticExpressionJS
ClientReportSendType.ALL_UNSENT = new ClientReportSendType(0 + 2)
// noinspection PointlessArithmeticExpressionJS
ClientReportSendType.ALL = new ClientReportSendType(0 + 3)

export { ClientReportSendType };

/**
 * Fast Binary Encoding ClientReportSendType field model
 */
class FieldModelClientReportSendType extends fbe.FieldModel {
  /**
   * Get the field size
   * @this {!FieldModelClientReportSendType}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the value
   * @this {!FieldModelClientReportSendType}
   * @param {ClientReportSendType=} defaults Default value, defaults is new ClientReportSendType()
   * @returns {!ClientReportSendType} Result value
   */
  get (defaults = new ClientReportSendType()) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return defaults
    }

    return new ClientReportSendType(this.readInt32(this.fbeOffset))
  }

  /**
   * Set the value
   * @this {!FieldModelClientReportSendType}
   * @param {!ClientReportSendType} value Value
   */
  set (value) {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return
    }

    this.writeInt32(this.fbeOffset, value.value)
  }
}

export { FieldModelClientReportSendType };
